export const EVENT_SEARCH_SUBMITTED_TERM_KEY = 'event_SearchSubmittedTerm';
export const EVENT_SEARCH_TYPE_KEY = 'event_SearchType';

export const KEYWORD_PREFIX = 'kw';
export const SPANISH_LANG_PREFIX = 'es';
export const LANG_CODE_REGEX = /^[a-z]{2,3}(-[a-z0-9]+)*$/i;
export const PRODUCT_URL_PATH = '/p/';
export const CATEGORY_URL_PATH = '/b/';

export const SEARCH_TYPE = {
	KEYWORD: 'keyword',
	SEARCH_RULE: 'Search rule (mayus)',
	SKU_PLUS_SKU: 'sku+sku',
	REGULAR: 'Regular',
	CATEGORY_REDIRECT: 'Category redirect',
	PRODUCT_REDIRECT: 'Product redirect',
	LANDING_REDIRECT: 'Landing redirect',
	TRANSLATED: 'Translated',
	NULL_SEARCH: 'Null search',
	SUGGESTED_TERM: 'Suggested term',
	SUGGESTED_BRAND: 'Suggested brand',
	SUGGESTED_LANDING: 'Suggested landing',
	RECENT_SEARCH: 'Recent search',
	RECENT_VIEWED: 'Recent viewed',
} as const;

export type GA4SearchType = (typeof SEARCH_TYPE)[keyof typeof SEARCH_TYPE];
